import Vue from 'vue';
import axios from 'axios';
import '../../../../filters';
import moment from 'moment';

export default {
  name: 'CaptureAdhocProperty',
  components: {

  },
  props: ['dataObj'],
  data: function () {
    return {
      appId: -1
    }
  },
  computed: {

  },
  watch: {

  },
  created() {
    this.$root.$on('capture_adhoc_property_updated', this.init);
    this.init();
  },
  methods: {
    init() {
      Vue.nextTick(() => {
        this.appId = this.dataObj.appId;

        console.log('CaptureAdHocPropertyActivity/GetData', this.dataObj);
      });
    }
  },
  
}

